import React from 'react';
import { ButtonGroup, Button } from '@nextui-org/react';

const MetricSelector = ({ selectedMetric, setSelectedMetric }) => {
  return (
    <div className="mb-4 flex justify-center">
      <ButtonGroup>
        <Button
          style={{
            backgroundColor: selectedMetric === 'unemployment' ? '#245BA9' : 'transparent',
            borderColor: '#245BA9',
            color: selectedMetric === 'unemployment' ? 'white' : '#245BA9'
          }}
          onClick={() => setSelectedMetric('unemployment')}
        >
          Unemployment Rate
        </Button>
        <Button
          style={{
            backgroundColor: selectedMetric === 'laborforce' ? '#245BA9' : 'transparent',
            borderColor: '#245BA9',
            color: selectedMetric === 'laborforce' ? 'white' : '#245BA9'
          }}
          onClick={() => setSelectedMetric('laborforce')}
        >
          Labor Force Rate
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default MetricSelector;